import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  inventoryTrackingTitle: {
    defaultMessage: 'Set Up Inventory Sync',
    id: 'CDOycF',
    description: 'Title for the inventory sync section',
  },
  inventoryTrackingDescription: {
    defaultMessage: 'Select the stores where you want ShipStation to update inventory counts to be your source of truth.',
    id: 'dwf36J',
    description: 'Description for the inventory tracking section',
  },
  syncInfo: {
    defaultMessage:
      "By activating your inventory sync settings, you confirm that ShipStation's inventory counts are accurate and authorize updates that <b>will overwrite existing counts</b> in your selected channels.",
    id: 'RxMkTy',
    description: 'Information about the inventory sync process',
  },
});
